import { render, staticRenderFns } from "./manage-games.vue?vue&type=template&id=4f55359f&scoped=true&"
import script from "./manage-games.vue?vue&type=script&lang=js&"
export * from "./manage-games.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f55359f",
  null
  
)

export default component.exports